
import React, {useState} from 'react';
import Hashtag from "./Hashtag";

const vorstand = [

  {
    "header":"1.Vorsitzender",
    "img": "./mitglieder/portrait0.png",
    "description":"Eckhardt Nebe"
  },  
  {
    "header":"2.Vorsitzender",
    "img": "./mitglieder/portrait3.png",
    "description":"Steffen Möbes"
  },
  {
    "header":"Schatzmeister",
    "img": "./mitglieder/portrait28.png",
    "description":"Bernd Günther"
  },
  {
    "header":"Schriftführer",
    "img": "./mitglieder/portrait27.png",
    "description":"Thomas Schütze"
  },  
  {
    "header":"Beisitzer",
    "img":"./mitglieder/portrait11.png",
    "description":"Matthias Wenisch"
  },
  {
    "header":"Beisitzer",
    "img":"./mitglieder/portrait19.png",
    "description":"Bernd Koch"
  }



  
 

]


function App(props) {  

    return (

      <div className="component-view animate" data-animate="blendin 3s">
         
         {
         vorstand.map(item=>(
      <div className="portrait-text-view" style={{maxWidth:500}} >
            <div className="text-item text-header">
            {item.header}
           </div>
           <img className="image-view" src={item.img}/>
          
           <div className="text-item ">
           {item.description}
           </div>            
       </div>
         ))
        }




    </div>
 
            );
        }
    
    export default App;